import noImage from "../../assets/icons/no-image.jpeg";

export const TabelBooleanText = ({ value = false }) => {
  return (
    <label className="inline-flex items-center">
      <label
        className={`relative w-11 h-6 bg-greyText rounded-full  ${
          value ? "bg-primary" : ""
        }`}
      >
        <label
          className={`absolute top-[2px] ${
            value ? "start-[calc(100%-22px)]" : "start-[2px]"
          } h-5 w-5 rounded-full transition-all bg-white`}
        />
      </label>
    </label>
  );
};

export const TabelArrayText = ({ arrayData = [] }) => {
  return (
    <span className="capitalize">
      {arrayData?.length > 0
        ? arrayData?.map((ele, index) => {
            return (
              <span key={index}>
                <span className="text-greyText">{index ? " | " : ""}</span>
                {ele ? ele : "--"}
              </span>
            );
          })
        : "--"}
    </span>
  );
};

export const TabelImage = ({ url }) => {
  return (
    <span>
      {url ? (
        <div className="w-[4rem] h-[4rem] my-1 rounded-md">
          <img crossorigin="anonymous" src={url} alt="url" className="w-full h-full rounded-md" />
        </div>
      ) : (
        <div className="w-[4rem] h-[4rem] my-1 rounded-md overflow-hidden">
          <img
            src={noImage}
            alt="No-image"
            className="rounded-md w-full h-full object-cover"
          />
        </div>
      )}
    </span>
  );
};
